import React, { useContext, useState } from "react";
import { Activity, currentRequestTimeStamp } from "../../../Constants";
import mixpanel from "mixpanel-browser";
import axios from "../../../Axios";
import { Urls } from "../../../Urls";
import { toast } from "react-toastify";
import "./NewEnquiry.css";
import { useMixPanelForTracking } from "../../../utils/TrackMixPanel";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../MyCompanyProfileContext";

const CancelEnquiry = ({
  item,
  apply_Filter,
  filters_applied,
  visible_enquiry,
  skipactive,
  fetchSpotData,
  currentFilterPayload,
  bucket,
}) => {
  const [remarks, setRemarks] = useState();
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  const onsubmitclicked = () => {
    Activity([
      {
        screen: "LoRRI Spot",
        module: `My Enquiries`,
        user_activity: `Enquiry Cancelled`,
        timestamp: currentRequestTimeStamp(),
        "userEmail" : userDetails?.email, "userName": userDetails?.user_name, "companyname":userDetails.company_name
              ? userDetails.company_name
              : userDetails.email
              ? userDetails.email.split("@")[1].split(".")[0]
              : ""
      },
    ]);
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - cancel enquiry",
      Data: `lane: ${item && item.origin && item.origin.location_name
        ? item.origin.location_name
        : ""
        } to ${item && item.destination && item.destination.location_name
          ? item.destination.location_name
          : ""
        } , truck type : ${item?.truck_types?.[0]?.label}`,
      Definition: `user clicked on cancel enquiry`,
    });
    document.getElementById("close_contactus").click();
    axios
      .post(`${Urls.spot}?delete_enquiry_v2=true`, {
        truck_enquiry_id: item.truck_enquiry_id,
        cancel_reason: remarks,
      })
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data.delete_status &&
          res.data.delete_status.status &&
          res.data.delete_status.status === "update_failed"
        ) {
          alert(res.data.delete_status.message);
        } else {
          toast.success("Enquiry Cancelled");
        }
        if (fetchSpotData && currentFilterPayload) {
          fetchSpotData(currentFilterPayload);
        } else {
          apply_Filter(
            filters_applied ? false : true,
            0,
            visible_enquiry,
            (skipactive - 1) * visible_enquiry + visible_enquiry,
            0,
            bucket || "active"
          );
        }
      });
  };

  return (
    <div>
      <div>
        <div>Remarks</div>
        <div>
          <input
            type="text"
            value={remarks}
            onInput={(e) => setRemarks(e.target.value)}
          />
        </div>
      </div>
      <center>
        <button className="btn btn-sm btn-success" onClick={onsubmitclicked}>
          Cancel Enquiry
        </button>
      </center>
    </div>
  );
};

export default CancelEnquiry;
